module.exports = __webpack_public_path__ + "files/0d8fa9d9810a6543e922ee3d90abac25.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700.woff
 ** module id = 962
 ** module chunks = 0
 **/